import { render, staticRenderFns } from "./ParseWeChatNewsInfo.vue?vue&type=template&id=1f098733&scoped=true&"
import script from "./ParseWeChatNewsInfo.vue?vue&type=script&lang=js&"
export * from "./ParseWeChatNewsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f098733",
  null
  
)

export default component.exports